import request from '@/utils/httpRequest'

export default class EquipmentAnnualInspection {
  queryEquipmentAnnualInspectionById(id) {
    return request({
      url: '/ding/Equipment/AnnualInspection/queryEquipmentAnnualInspectionById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow(params) {
    return request({
      url: '/equipment/wuyeEquipmentAnnualInspection/startFlow',
      method: 'post',
      data: params
    })
  }


}
